export const SCRIPT_REQUEST_LOG_RESET = '@SCRIPT_REQUEST_LOG/RESET';
export const SCRIPT_REQUEST_LOG_CHANGE_FILTER = '@SCRIPT_REQUEST_LOG/CHANGE_FILTER';
export const SCRIPT_REQUEST_LOG_CLEAR_FILTER = '@SCRIPT_REQUEST_LOG/CLEAR_FILTER';

export const resetData = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_LOG_RESET });
  };
};

export const changeFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_LOG_CHANGE_FILTER, payload: filter });
  };
};

export const clearFilter = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_LOG_CLEAR_FILTER });
  };
};

